import "./Dashboard.scss";
import DashboardTopCard from "./DashboardTopCard/DashboardTopCard";
import { useTranslation } from "react-i18next";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import DashboardCircle from "./DashboardCircle/DashboardCircle";
import DashboardBottomCard from "./DashboardBottomCard/DashboardBottomCard";
import { ISummaryStatistics, StatsRevenuePeriodsEnum } from "../../models/Statistics";
import { useState } from "react";
import { useGetStatisticsRevenueQuery, useGetStatisticSummaryQuery } from "../../api/queries";

const initialSummaryStat: ISummaryStatistics = {
  totalRevenues: {
    direction: "neutral",
    percent: 0,
    total: 0,
  },
  totalVisitors: {
    direction: "neutral",
    percent: 0,
    total: 0,
  },
  newSignUps: {
    direction: "neutral",
    percent: 0,
    total: 0,
  },
  gyms: [
    { value: 0, name: "Approved", color: "#23C55E" },
    { value: 0, name: "UnderReview", color: "F77C4C" },
    { value: 0, name: "Declined", color: "#ff1919" },
  ],
  users: [
    { value: 0, name: "Active", color: "#23C55E" },
    { value: 0, name: "Inactive", color: "#9e9e9e" },
    { value: 0, name: "Trial", color: "#3B82F6" },
    { value: 0, name: "Deleted", color: "#ff1919" },
  ],
};

const Dashboard = () => {
  const { t } = useTranslation();

  const [activeRevenuePeriodOnDays, setActiveRevenuePeriodOnDays] =
    useState<StatsRevenuePeriodsEnum>(StatsRevenuePeriodsEnum.YEAR);

  const { data: summaryStatistic = initialSummaryStat } = useGetStatisticSummaryQuery();
  const { data: revenueStatistics = [] } = useGetStatisticsRevenueQuery(activeRevenuePeriodOnDays);

  return (
    <div className={"page-content dashboard-page"}>
      <div className={"top-wrapper"}>
        <DashboardTopCard
          title={t("TotalRevenues")}
          value={summaryStatistic.totalRevenues.total}
          percentValue={summaryStatistic.totalRevenues.percent}
          percentValueType={summaryStatistic.totalRevenues.direction}
        />
        <DashboardTopCard
          title={t("TotalVisitors")}
          value={summaryStatistic.totalVisitors.total}
          percentValue={summaryStatistic.totalVisitors.percent}
          percentValueType={summaryStatistic.totalVisitors.direction}
        />
        <DashboardTopCard
          title={t("NewSignups")}
          value={summaryStatistic.newSignUps.total}
          percentValue={summaryStatistic.newSignUps.percent}
          percentValueType={summaryStatistic.newSignUps.direction}
        />
      </div>
      <div className={"revenue-wrapper"}>
        <div className={"header"}>
          <div className={"left"}>
            <h3>{t("Revenue")}</h3>
          </div>
          <div className={"right"}>
            <button
              onClick={() => setActiveRevenuePeriodOnDays(StatsRevenuePeriodsEnum.YEAR)}
              className={`btn ${activeRevenuePeriodOnDays === StatsRevenuePeriodsEnum.YEAR && "active"}`}
            >
              12 {t("Months")}
            </button>
            <button
              onClick={() => setActiveRevenuePeriodOnDays(StatsRevenuePeriodsEnum.HALF_YEAR)}
              className={`btn ${activeRevenuePeriodOnDays === StatsRevenuePeriodsEnum.HALF_YEAR && "active"}`}
            >
              6 {t("Months")}
            </button>
            <button
              onClick={() => setActiveRevenuePeriodOnDays(StatsRevenuePeriodsEnum.MONTH)}
              className={`btn ${activeRevenuePeriodOnDays === StatsRevenuePeriodsEnum.MONTH && "active"}`}
            >
              30 {t("Days")}
            </button>
            <button
              onClick={() => setActiveRevenuePeriodOnDays(StatsRevenuePeriodsEnum.WEEK)}
              className={`btn ${activeRevenuePeriodOnDays === StatsRevenuePeriodsEnum.WEEK && "active"}`}
            >
              7 {t("Days")}
            </button>
          </div>
        </div>
        <ResponsiveContainer height={200}>
          <AreaChart data={revenueStatistics} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis hide={true} />
            <Tooltip />
            <Area type="monotone" dataKey="uv" stroke="#FF8C42" fill="#F7E1D8" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className={"circles-wrapper"}>
        <DashboardCircle title={"Gyms"} data={summaryStatistic.gyms} />
        <DashboardCircle title={"Users"} data={summaryStatistic.users} />
      </div>
      <div className={"bottom-wrapper"}>
        <h2 className={"title"}>{t("TopGymsForLastMonth")}</h2>
        <div className={"wrapper"}>
          <DashboardBottomCard
            title={"Pilates Antonia Gym"}
            value={4350}
            percentValue={34}
            percentValueType={"up"}
          />
          <DashboardBottomCard
            title={"Pilates Antonia Gym"}
            value={3950}
            percentValue={25}
            percentValueType={"down"}
          />
          <DashboardBottomCard
            title={"Pilates Antonia Gym"}
            value={4350}
            percentValue={34}
            percentValueType={"up"}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
